// Copyright (c) 2016 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const Facets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet,
    isInitialLoad: t.Boolean,
    requestDateFacet: t.struct({
        dateRange: DateRange,
        maxDate: t.maybe(t.Number),
        minDate: t.maybe(t.Number)
    }),
    requestTypes: t.struct({
        allowedTypes: t.list(KeyValuePair, 'AllowedRequestTypes'),
        selectedTypes: t.list(KeyValuePair, 'SelectedRequestTypes')
    }),
    statusFacet: t.struct({
        allowedStatuses: t.list(KeyValuePair, 'allowedStatuses'),
        selectedStatuses: t.list(KeyValuePair, 'SelectedStatuses')
    })
}, 'Facets');

export const getDefaultState = () =>
    new Facets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState(),
        isInitialLoad: true,
        requestDateFacet: {
            dateRange: {
                from: null,
                to: null
            }
        },
        requestTypes: {
            allowedTypes: [],
            selectedTypes: []
        },
        statusFacet: {
            allowedStatuses: [],
            selectedStatuses: []
        }
    });

export default Facets;



// WEBPACK FOOTER //
// ./src/part-requests/search/state/facets.js